// extracted by mini-css-extract-plugin
export default {"section":"H8TDy","preview":"JTfCM","previewImg":"Ko5oO","inner":"xkceM","content":"cmV6v","text":"R1ElN","info":"fNyRL","infoText":"eeNAl","actions":"dq0Pw"};